import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

import { useLanguage } from './languageContext';

const SITE_URL = 'https://pierresaumet.com';
const OG_IMAGE = `${SITE_URL}/icon-512.png`;

export default function Seo({ title, description, noindex = false }) {
  const { language } = useLanguage();
  const { pathname } = useLocation();
  const canonicalUrl = `${SITE_URL}${pathname}`;

  return (
    <Helmet htmlAttributes={{ lang: language }}>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />

      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={OG_IMAGE} />

      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />

      {noindex && <meta name="robots" content="noindex, nofollow" />}
    </Helmet>
  );
}
